/**
 * An enum explaining the reasons why the local device was deactivated.
 */
export var DeviceDeactivatedReason;
(function (DeviceDeactivatedReason) {
    /**
     * The local player was disabled, due to either a local or remote logout
     * command, or due to disconnection.
     */
    DeviceDeactivatedReason["LOCAL_PLAYER_DISABLED"] = "local_player_disabled";
    /**
     * The playback was stopped due to a command from Track Playback or a local
     * event, such as capping reached or playback failure.
     */
    DeviceDeactivatedReason["STOPPED"] = "stopped";
    /**
     * The playback was stopped because another device became active.
     */
    DeviceDeactivatedReason["REMOTE_ACTIVATED"] = "remote_activated";
    /**
     * The reason for the deactivation is unknown.
     */
    DeviceDeactivatedReason["UNKNOWN"] = "unknown";
})(DeviceDeactivatedReason || (DeviceDeactivatedReason = {}));
//# sourceMappingURL=device_deactivated_reason.js.map